import { create } from 'zustand';
import Cookies from 'js-cookie';

const useTokenStore = create((set) => {
    const initialState = {
        token: null,
        created_at: null,
    };

    const hydrateStore = async () => {
        const tokenData = Cookies.get('deepsy_auth');
        if (tokenData) {
            set(JSON.parse(tokenData));
        }
    };

    return {
        ...initialState,
        hydrateStore, // Expose hydrateStore to be called manually, not a permanent solution, will do for now.
        setToken: (token, rememberMe = false) => {
            const created_at = new Date().toISOString();
            const tokenData = { token, created_at };

            const isSecure = window.location.protocol === 'https:';
            const options = rememberMe
                ? { expires: 7, secure: isSecure, sameSite: 'Strict' } // 1 week
                : { secure: isSecure, sameSite: 'Strict' }; // Session

            Cookies.set('deepsy_auth', JSON.stringify(tokenData), options);

            set({ ...tokenData });
        },
        clearToken: () => {
            Cookies.remove('deepsy_auth');
            set(initialState);
        },
    };
});

export default useTokenStore;